import Googleplay from '../../../assets/img/googlePlay.png';
import Appstore from '../../../assets/img/appStore.png';

import './styles.css';
const Download = () =>{
  return(
    <div className="container-fluid division3 download">
      <div className="container text-primary">
        <h1 className="pt-5">
          download now! free for android and ios
        </h1>
        <p className="py-3 w-75">
          Lorem Ipsum is simply dummy text of the printing and 
          typesetting industry. Lorem Ipsum has been the industry's
          standard dummy text ever since the 1500s
        </p>
        <div className="row justify-content-end py-4">
          <img
          src={Googleplay}
          className="mr-2 pointer"
          alt="..."
          />
          <img
          src={Appstore}
          className="pointer"
          alt="..."
          />
        </div>
      </div>
    </div>
  );
};
export default Download;